import { useState } from "react";
import { useHubInfo } from "./api.js";
import { useActiveHub } from "./activeHub.js";
export function tokenLabel(info) {
    return info.name || `${info.token.slice(0, 14)}...`;
}
const STORAGE_KEY = "quickstart_selected_token";
export function useSelectedToken() {
    const { activeHubId } = useActiveHub();
    const { data } = useHubInfo(activeHubId);
    const infos = data?.agent_tokens ?? [];
    const [selected, setSelected] = useState(() => typeof window !== "undefined"
        ? (localStorage.getItem(STORAGE_KEY) ?? "")
        : "");
    const resolved = infos.some((i) => i.token === selected)
        ? selected
        : (infos[0]?.token ?? "");
    const setSelectedToken = (token) => {
        if (typeof window !== "undefined") {
            localStorage.setItem(STORAGE_KEY, token);
        }
        setSelected(token);
    };
    return {
        selectedToken: resolved || undefined,
        setSelectedToken,
        tokenInfos: infos,
    };
}
